module.exports = __webpack_public_path__ + "img/calendar.5b54faa4.svg";